export const model = {
    id:  null,
    image: "",
  

};
